import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    AccountClient,
    AccountMapResult,
    AccountView,
    AccountViewPaginatedResultDto,
    BuildingProductTypeView,
    QuickSearchAccountParameters,
    SearchAccountParameters,
    SearchAccountsMapParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    constructor(private readonly client: AccountClient) {}

    async getById(id: number): Promise<AccountView> {
        return await lastValueFrom(this.client.accountGetById(id));
    }

    async save(body: AccountView): Promise<AccountView> {
        return await lastValueFrom(this.client.accountSave(body));
    }

    async activate(id: number): Promise<void> {
        await lastValueFrom(this.client.accountActivate(id));
    }

    async deactivate(id: number): Promise<void> {
        await lastValueFrom(this.client.accountDeactivate(id));
    }

    async search(body: QuickSearchAccountParameters | undefined): Promise<AccountView[]> {
        return await lastValueFrom(this.client.accountQuickSearch(body));
    }

    async searchAccount(body: SearchAccountParameters | undefined): Promise<AccountViewPaginatedResultDto> {
        return await lastValueFrom(this.client.accountSearch(body));
    }

    async searchMap(body: SearchAccountsMapParameters): Promise<AccountMapResult[]> {
        return await lastValueFrom(this.client.accountMapSearch(body));
    }

    async getBuildingProductTypes(id: number): Promise<BuildingProductTypeView[]> {
        return await lastValueFrom(this.client.accountGetBuildingProductTypes(id));
    }
}
